<script lang="ts" setup>
const { getListAttributes, getMetaAttributes } = useApiAttributes()
const { t } = useI18n()

const endpoints: ApiEndpoint[] = [
  {
    method: 'GET',
    path: '/lists',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.page'),
    example: '/lists?page=1',
    name: 'page',
    optional: true,
    type: 'number',
  },
  {
    description: t('attributes.size'),
    example: '/lists?size=10',
    name: 'size',
    optional: true,
    type: 'number',
  },
]

const responseAttributes: ApiAttribute[] = [
  {
    attributes: getListAttributes(),
    description: t('response.lists'),
    name: 'lists',
    type: 'array',
  },
  getMetaAttributes(),
]

const response = {
  lists: [
    {
      analytics: { companiesCount: 1771 },
      createdAt: '2022-04-01T13:07:14.000+00:00',
      dynamic: false,
      id: 4246,
      imported: false,
      integrations: [
        {
          apiKey: 'My_AP1_T0k3n',
          id: 14,
          slug: 'pipedrive',
          status: 'connected',
          statusDetails: null,
        },
      ],
      name: 'US Companies using Node.js',
      processActive: false,
      processingAt: '2022-04-01T13:07:15.000+00:00',
      processInitialized: true,
      query: [
        {
          attribute: 'technologies',
          blockedOperator: false,
          operator: 'or',
          sign: 'equals',
          values: ['node-js'],
        },
        {
          attribute: 'country.code',
          blockedOperator: true,
          operator: 'or',
          sign: 'equals',
          values: ['us'],
        },
      ],
    },
    {
      analytics: { companiesCount: 943 },
      createdAt: '2022-02-22T07:23:52.000+00:00',
      dynamic: false,
      id: 3837,
      imported: false,
      integrations: [],
      name: 'Edtech Companies',
      processActive: false,
      processingAt: '2022-02-22T07:23:53.000+00:00',
      processInitialized: true,
      query: [
        {
          attribute: 'about.industries',
          blockedOperator: false,
          operator: 'or',
          sign: 'equals',
          values: ['edtech'],
        },
      ],
    },
  ],
  meta: {
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 4,
  },
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :query-attributes="queryAttributes"
    :response="response"
    :response-attributes="responseAttributes"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "page": "The page to fetch (default: 1).",
      "size": "The number of lists to be returned (between 1 and 100). Default to 10."
    },
    "response": {
      "lists": "The lists that belong to your team."
    }
  },
  "es": {
    "attributes": {
      "page": "La página a recuperar (por defecto: 1).",
      "size": "El número de listas a recuperar (entre 1 y 100). Por defecto a 10."
    },
    "response": {
      "lists": "Las listas que pertenezcan a tu equipo."
    }
  },
  "fr": {
    "attributes": {
      "page": "La page à récupérer (par défaut: 1).",
      "size": "Le nombre de listes à récupérer (entre 1 et 100). Par défaut à 10."
    },
    "response": {
      "lists": "Les listes qui appartiennent à votre équipe."
    }
  }
}
</i18n>
